import { render, staticRenderFns } from "./headlines.vue?vue&type=template&id=1d114214&scoped=true&"
import script from "./headlines.vue?vue&type=script&lang=js&"
export * from "./headlines.vue?vue&type=script&lang=js&"
import style0 from "./headlines.vue?vue&type=style&index=0&id=1d114214&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d114214",
  null
  
)

export default component.exports